module.exports = __webpack_public_path__ + "fonts/iconfont.5b9eb600.woff";